import { CreationOperactionsConfigService } from './shared/creation-operation.config.service';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnDestroy } from '@angular/core';
import {
  OperacionesControl,
  BaseControl,
  ValoresOperacionesControl,
  ConfirmComponent,
  Forma,
  TipoControl,
  Control,
} from '@app/shared';
import { FormGroup } from '@angular/forms';
import { LocalDataSource } from 'ng2-smart-table';
import {
  CreationOperactionFormsService
} from './shared/creation-operation.forms.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-creation-operation-condition',
  templateUrl: './creation-operation-condition.component.html',
  styleUrls: ['./creation-operation-condition.component.scss'],
  providers: [CreationOperactionFormsService]
})
export class CreationOperationConditionComponent implements OnInit, OnDestroy {

  // Define cuando se agrega o se modifica una operacion
  @Input() updateOperation = false;
  // Contiene la operacion a modificar
  @Input() controlOperationsI: OperacionesControl;
  // Contiene la forma principal
  @Input() formPrincipal: Forma;
  // Define el tipo de control actual
  @Input() typeControl: TipoControl;
  // Contiene el formulario del control
  @Input() formulario: Array<Control> = [];
  // String que identifica la accion a realizar
  actionForm = 'Agregar';
  // Pregunta de la modal de confirmaciones
  question = '';
  // Define cuando se muestra el formulario para agregar o modificar el campo del valor
  formValueOperation = false;
  // Define cuando se agrega o se modifica una operacion
  updateValueOperation = false;
  // Contiene los controles del formulario
  controls: BaseControl<any>[] = [];
  // Contiene los valores de las referencias de las operaciones
  operationsValues: ValoresOperacionesControl[] = [];
  // Contiene la configuracion de la operacion
  controlOperations: OperacionesControl;
  // Referencia al formulario de creacion o edicion de la operacion
  formValues: FormGroup;
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Configuracion de la tabla
  settings = {};
  // Contiene la data de la fila seleccionada
  rowSelect = {};
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Salida del evento de cerrar el componente de creacion de operaciones
  @Output() close: EventEmitter<boolean> = new EventEmitter();
  // Salida del evento de guardar las operaciones
  @Output() saveOperation: EventEmitter<OperacionesControl> = new EventEmitter();

  constructor(
    private cofs: CreationOperactionFormsService
  ) { }

  ngOnInit() {
    if (this.updateOperation) {
      this.controlOperations = {
        operacion: this.controlOperationsI.operacion,
        valores:  this.controlOperationsI.valores,
        index: this.controlOperationsI.index,
        ejecutar_siempre: this.controlOperationsI.ejecutar_siempre,
      };
      this.operationsValues = this.controlOperations.valores;
      this.actionForm = 'Modificar';
    }
    this.controls = this.cofs.getOperaction(this.controlOperations, this.typeControl);

    const configTable = new CreationOperactionsConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      this.defineActionOperations(res.action, res.data);
    });
    this.loadingOperationsValues();
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Define la accion arealizar en la tabla de valores de referencias en la operacion
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof CreationOperationComponent
   */
  defineActionOperations(action: 'add' | 'update' | 'delete' = 'add', data?: any) {
    switch (action) {
      case 'add':
        this.formValueOperation = true;
        this.updateValueOperation = false;
        break;
      case 'update':
        this.formValueOperation = true;
        this.updateValueOperation = true;
        this.rowSelect = data;
        break;
      case 'delete':
        this.rowSelect = data;
        this.updateValueOperation = false;
        this.question = '¿Realmente desea eliminar el valor?';
        this.confirm.open();
        break;
    }
  }

  /**
   * Emite el cierre del componente
   *
   * @memberof CreationOperationComponent
   */
  closeComponent() {
    this.close.emit(true);
  }

  /**
   * Cierra el componente de creacion de valores para las referencias en las operaciones
   *
   * @param {boolean} res
   * @memberof CreationOperationComponent
   */
  closeFormValue(res: boolean) {
    if (res) {
      this.formValueOperation = false;
    }
  }

  /**
   * Optine el formulario de creacion de operacion
   *
   * @param {*} data
   * @memberof CreationOperationComponent
   */
  form(data: any) {
    this.formValues = data;
  }

  /**
   * Guarda la configuracion de la operacion
   *
   * @memberof CreationOperationComponent
   */
  save() {
    if ((this.formValues.valid || this.formValues.status !== 'INVALID') &&
        this.operationsValues &&
        this.operationsValues.length
      ) {
      if (this.updateOperation) {
        this.controlOperations.operacion = this.formValues.controls['txtOperacion'].value;
        this.controlOperations.valores = this.operationsValues;
        this.controlOperations.ejecutar_siempre = this.formValues.controls['chkEjecutar'].value;
      } else {
        this.controlOperations = {
          operacion: this.formValues.controls['txtOperacion'].value,
          valores: this.operationsValues,
          ejecutar_siempre: this.formValues.controls['chkEjecutar'].value
        };
      }
      this.saveOperation.emit(this.controlOperations);
    }
  }

  /**
   * Guarda o modifica el valor de la referencia a la operacion actual
   *
   * @param {ValoresOperacionesControl} operation
   * @memberof CreationOperationComponent
   */
  saveOperationValue(operation: ValoresOperacionesControl) {
    if (this.updateValueOperation) {
      this.operationsValues.forEach((value, indexVal) => {
        if (value.index === operation.index) {
          this.operationsValues[indexVal] = operation;
          this.loadingOperationsValues();
        }
      });
      this.updateValueOperation = false;
    } else {
      this.operationsValues.push(operation);
      this.loadingOperationsValues();
    }
    this.closeFormValue(true);
  }

  /**
   * Define la accion a realiar despues de la respuesta en la confirmacion
   *
   * @param {boolean} res
   * @memberof CreationOperationComponent
   */
  actionComfirm(res: boolean) {
    if (res) {
      this.deleteOperation(this.rowSelect['index']);
      this.rowSelect = {};
    }
    this.question = '';
  }

  /**
   * Elimina un valor de la referencia de la tabla
   *
   * @private
   * @param {number} index
   * @memberof CreationOperationComponent
   */
  private deleteOperation(index: number) {
    this.operationsValues.forEach((value, indexVal) => {
      if (value.index === index) {
        this.operationsValues.splice(indexVal, 1);
        this.loadingOperationsValues();
      }
    });
  }

  /**
   * Se encarga de refrescar los datos de la tabla que contiene los valores de la referencia
   *
   * @private
   * @memberof CreationOperationComponent
   */
  private loadingOperationsValues() {
    this.operationsValues.forEach((value, index) => {
      value.index = index;
    });
    this.sourceData = new LocalDataSource(this.operationsValues);
    this.sourceData.refresh();
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/conditions/operations-condition-form/creation-operation-condition/creation-operation-condition.component.ts